import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';

import GlobalModals from '@/features/globalModals/GlobalModals';
import TopBar from '@/Shared/TopBar/TopBar';
import { ErrorFallback } from '@/Components/util/error-fallback/ErrorFallback';
import { NavBar } from '@/_components/layout/nav-bar';
import { FullPageLoading } from '@/_components/layout/full-page-loading';

function AppLayout() {
  return (
    <>
      <NavBar />
      <TopBar />
      <div className="general-container">
        <ErrorBoundary
          // TODO fix lint error
          // eslint-disable-next-line react/no-unstable-nested-components
          fallback={({ ...props }) => <ErrorFallback {...props} />}
        >
          <Suspense fallback={<FullPageLoading />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      </div>
      <GlobalModals />
    </>
  );
}

export default AppLayout;
